module.exports = __webpack_public_path__ + "inputs/img/banner5.39db8707.png";